<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import InputText from 'primevue/inputtext';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "chapter-edit",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      v$: useVuelidate(),
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      chapterId: this.$route.params.id,
      title: "",
      description: "",
      imageEntry: "",
      fileData: "",
      formSending: false,
    };
  },
  components: {
    Breadcrumb,
    InputText,
  },
  validations() {
    return {
      title: { required },
      // description: { required },
    };
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    basePath() {
      return this.isCourseScope
          ? `/courses/${this.courseId}/chapters`
          : `/chapter/${this.gradeSlug}`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [
          ...base,
          { name: 'الأبواب', path: this.basePath },
          { name: 'تعديل باب', path: `${this.basePath}/edit/${this.chapterId}` },
        ];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: 'الأبواب', path: this.basePath },
        { name: 'تعديل باب', path: `${this.basePath}/edit/${this.chapterId}` },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() {
      return this.resolvedGrade?.id ?? null;
    },
  },
  methods: {
    onFileChange(event) {
      this.fileData = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.fileData);
      reader.onload = () => (this.imageEntry = reader.result);
    },
    showChapter() {
      axios
          .get(`/lessons/${this.chapterId}`)
          .then((response) => {
            const chapter = response.data;
            this.title = chapter.title;
            this.description = chapter.description;
            if (chapter.image) {
              this.imageEntry = chapter.image;
            }
          })
          .catch((error) => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: error.response.data.message,
            });
          });
    },
    sendForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        const formData = new FormData();
        formData.append('title', this.title);
        formData.append('description', this.description);
        if (this.fileData) {
          formData.append('image', this.fileData);
        }
        this.formSending = true;

        axios
            .post(`/lessons/${this.chapterId}?_method=PUT`, formData)
            .then(() => {
              this.formSending = false;
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم التعديل بنجاح",
              });
              this.$router.push(this.basePath);
            })
            .catch((error) => {
              this.formSending = false;
              Swal.fire({
                position: "center",
                icon: "error",
                title: error.response.data.message,
              });
            });
      }
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    this.showChapter();
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">
    <form class="row" @submit.prevent="sendForm()">
      <div class="col-lg-4 col-md-6 col-12 mb-4">
        <div class="d-flex flex-column gap-2">
          <label for="title">اسم الباب</label>
          <InputText id="title" v-model="title" aria-describedby="title-help" />
          <span class="text-danger" v-if="v$.title.$error">برجاء ادخال اسم الباب</span>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <div class="d-flex flex-column gap-2">
          <label for="description">وصف الباب</label>
          <InputText id="description" v-model="description" aria-describedby="description-help" />
          <!-- <span class="text-danger" v-if="v$.description.$error">برجاء ادخال وصف الباب</span> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12 mb-4">
        <div class="d-flex flex-column gap-2">
          <label for="certificateImage">صورة الباب</label>
          <label for="certificateImage" class="upload_img btn primaryButtonOutline">
            <p class="mb-0 mx-2" v-if="imageEntry == ''">برجاء رفع صورة الباب</p>
            <p class="mb-0 mx-2" v-else-if="imageEntry">{{ fileData.name }}</p>
            <i class="pi pi-cloud-upload border-2 border-circle text-8xl text-400 border-400" />
          </label>
          <input
              type="file"
              id="certificateImage"
              class="form-control"
              @change="onFileChange"
              hidden
              accept="image/png, image/gif, image/jpeg, image/jpg"
          />
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <label for="button" class="non-visible">ارسال</label>
        <button type="submit" class="btn primaryButton w-100" :disabled="formSending"><i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i> {{ formSending ? 'جاري الارسال...' : 'إرسال' }}</button>
      </div>
    </form>
  </div>
</template>

<style scoped>

</style>
